import React, { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { Button, Paper, Typography } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useRouter } from "next/router";
import Head from "next/head";

const PREFIX = "PageNotFoundContainer";

const classes = {
  paper: `${PREFIX}-paper`,
};

const Root = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.primary.main,

  [`& .${classes.paper}`]: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(4, 3),
    textAlign: "center",
    width: "50%",
    gap: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
  },
}));

const PageNotFoundContainer = () => {
  const router = useRouter();

  return (
    <Fragment>
      <Head>
        <title>{`Page Not Found | Powered by Carte`}</title>
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        <meta name="robots" content="index, follow" />
      </Head>
      <Root>
        <Paper className={classes.paper}>
          <Search color="inherit" style={{ fontSize: "70px" }} />
          <Typography variant="h6">
            {"We can't seem to find the page you are accessing!"}
          </Typography>
          <Button variant="contained" color="secondary" onClick={() => router.push(`/`)}>
            Return to shop
          </Button>
        </Paper>
      </Root>
    </Fragment>
  );
};

export default PageNotFoundContainer;
